module.exports = __webpack_public_path__ + "static/media/kubernetes.506db519.svg";